<section class="order-plannng-container">
    <div class="row">
        <div class="col-md-12">
            <app-breadcrumb [routePath]="'/customer-order'" [title]="'ORDERMANAGEMENT.MANAGEORDERS.title'"
                [title2]="'ORDERMANAGEMENT.MANAGEORDERS.OrderDetail'">
            </app-breadcrumb>
        </div>
        <div class="col-md-12">
            <div class="common-stepper">
                <mat-horizontal-stepper linear labelPosition="bottom" #stepper>
                    <mat-step [completed]="isStep1Valid">
                        <ng-template matStepLabel>
                            <img src="assets/images/People Scope Details.svg" />
                            <p>{{'ORDERMANAGEMENT.MANAGEORDERS.OrderBasicDetails' | translate}}</p>
                        </ng-template>
                        <div class="box-style">
                            <app-view-order-history [planning]="true"></app-view-order-history>
                            <div class="form-footer p-5">
                                <div class="step-form-bottom">
                                    <div>
                                        <button routerLink="/customer-order"
                                            class="btn-style red-line-btn" type="button">{{'GENERAL.Cancel' | translate}}</button>
                                    </div>
                                    <div>
                                        <button (click)="nextStep()" matStepperNext
                                            class="btn-style theme-btn">{{'GENERAL.Next' |
                                            translate}} <span class="material-icons">arrow_forward</span></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-step>
                    <mat-step [completed]="isStep2Valid">
                        <ng-template matStepLabel>
                            <img src="assets/images/Documents.svg" />
                            <p>{{'ORDERMANAGEMENT.MANAGEORDERS.OrderPlanning' | translate}}</p>
                        </ng-template>
                        <div class="box-style p-5">
                            <div>

                                <div class="row">
                                    <div class="col-md-3">
                                        <mat-form-field appearance="outline" class="element-full-width">
                                            <mat-label>{{'ORDERMANAGEMENT.MANAGEORDERS.SellingCatalog' | translate}}</mat-label>
                                            <mat-select [(ngModel)]="selectedCatalog"
                                                [disabled]="orderDetails?.items?.length > 0 ? true : false"
                                                >
                                                <mat-option *ngFor="let catalog of catalogs" [value]="catalog.sellingCatalogId">
                                                    {{ catalog.sellingCatalogName }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-form-field appearance="outline" class="element-full-width">
                                            <mat-label>{{'ORDERMANAGEMENT.MANAGEORDERS.TotalSellingPrice' |
                                                translate}}</mat-label>
                                            <!-- <input matInput type="text" [(ngModel)]="totalSellingPrice" disabled>
                                            <mat-icon matSuffix class="currency-icon euro-icon">euro</mat-icon> -->

                                            <input *ngIf="currentLanguage === 'it'" [disabled]="true"
                                            thousandSeparator="." [(ngModel)]="totalSellingPrice" matInput
                                            mask="separator.2" decimalMarker="," type="text" [suffix]="' € '" />
                                
                                        <input *ngIf="currentLanguage === 'en'" [disabled]="true"
                                            thousandSeparator="," [(ngModel)]="totalSellingPrice" matInput
                                            mask="separator.2" decimalMarker="." type="text" [suffix]="' € '" />

                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-form-field appearance="outline" class="element-full-width">
                                            <mat-label>{{'ORDERMANAGEMENT.MANAGEORDERS.DiscountedSellingPrice' |
                                                translate}}</mat-label>
                                            <!-- <input matInput type="number" min="0" [disabled]="disabledMode"
                                                [(ngModel)]="discountedPrice">
                                            <mat-icon matSuffix class="currency-icon euro-icon">euro</mat-icon> -->

                                            <input *ngIf="currentLanguage === 'it'" [disabled]="disabledMode"
                                            thousandSeparator="." [(ngModel)]="discountedPrice" matInput
                                            mask="separator.2" decimalMarker="," type="text" [suffix]="' € '" />
                                
                                        <input *ngIf="currentLanguage === 'en'" [disabled]="disabledMode"
                                            thousandSeparator="," [(ngModel)]="discountedPrice" matInput
                                            mask="separator.2" decimalMarker="." type="text" [suffix]="' € '" />

                                        </mat-form-field>
                                    </div>


                                    <div class="col-md-3">
                                        <mat-form-field appearance="outline" class="element-full-width">
                                            <mat-label>{{'ORDERMANAGEMENT.MANAGEORDERS.ETC' | translate}}</mat-label>
                                            <input matInput type="text" [(ngModel)]="etc" disabled>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="overflow-x-auto table-container mat-elevation-z8">
                                    <table mat-table [dataSource]="dataSource">

                                        <ng-container matColumnDef="name">
                                            <th mat-header-cell *matHeaderCellDef class="name-withoud-dot-column">
                                                <span> {{'ORDERMANAGEMENT.MANAGEORDERS.Name' | translate}} </span>
                                                <span class="search-form-wrapper"
                                                    style="display: inline-block;margin-left: 5px">
                                                    <span class="search-form">
                                                        <mat-icon matPrefix
                                                            class="material-icons search">search</mat-icon>
                                                        <input style="width: 160px;height:40px"
                                                            (keyup)="onKeyUp(searchBox.value)" #searchBox
                                                            [(ngModel)]="search" mat-input
                                                            placeholder="{{'ORDERMANAGEMENT.SEARCH'| translate}}" />
                                                        <mat-icon *ngIf="this.search !== '' "
                                                            class="material-icons clear"
                                                            (click)="resetSearch()">clear</mat-icon>
                                                    </span>
                                                </span>
                                            </th>
                                            <td mat-cell *matCellDef="let data" class="name-column"
                                                [class.disabled-row]="data.disable">
                                                <button mat-icon-button
                                                    [style.visibility]="!data.expandable ? 'hidden' : ''"
                                                    [style.marginLeft.px]="data.level * 32"
                                                    (click)="treeControl.toggle(data)">
                                                    <mat-icon class="mat-icon-rtl-mirror">
                                                        {{treeControl.isExpanded(data) ? 'expand_more' :
                                                        'chevron_right'}}
                                                    </mat-icon>
                                                </button>
                                                 <span [matTooltip]="data.name">
                                                     {{data.name}}
                                                </span>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="priceType">
                                            <th mat-header-cell *matHeaderCellDef class="price-column">  {{'ORDERMANAGEMENT.MANAGEORDERS.PriceType' |
                                                translate}} </th>
                                            <td mat-cell *matCellDef="let data" class="price-column"
                                                [class.disabled-row]="data.disable">

                                                {{data.priceType}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="qty">
                                            <th mat-header-cell *matHeaderCellDef class="qty-column">
                                                {{'ORDERMANAGEMENT.MANAGEORDERS.Qty' |
                                                translate}} </th>
                                            <td mat-cell *matCellDef="let data" class="qty-column"
                                                [class.disabled-row]="data.disable">

                                                <span >{{data.qty}}</span>

                                            </td>
                                        </ng-container>



                                        <ng-container matColumnDef="sellingPrice">
                                            <th mat-header-cell *matHeaderCellDef class="selling-price-column">
                                                {{'ORDERMANAGEMENT.MANAGEORDERS.SellingPrice' | translate}} </th>
                                            <td mat-cell *matCellDef="let data" class="selling-price-column"
                                                [class.disabled-row]="data.disable">

                                                <span class="selling-price-column"
                                                    >
                                                    {{(data.sellingPrice | customCurrency)}}
                                                    <!-- <mat-icon class="currency-icon euro-icon">euro</mat-icon> -->
                                                </span>

                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="etc">
                                            <th mat-header-cell *matHeaderCellDef class="etc-column">
                                                {{'ORDERMANAGEMENT.MANAGEORDERS.ETC' |
                                                translate}} </th>
                                            <td mat-cell *matCellDef="let data" class="etc-column"
                                                [class.disabled-row]="data.disable">
                                                <span >{{(data.customize  && data.hasChild) ? (data?.etcNewData?.time | customTimeDuration:data?.etcNewData?.type):
                                                      (data?.expectedTimeToDeliver?.time | customTimeDuration:data?.expectedTimeToDeliver?.type)}}</span>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="totalSellingPrice">
                                            <th mat-header-cell *matHeaderCellDef class="total-selling-price-column">
                                                {{'ORDERMANAGEMENT.MANAGEORDERS.TotalSellingPrice' | translate}} </th>
                                            <td mat-cell *matCellDef="let data" class="total-selling-price-column"
                                                [class.disabled-row]="data.disable">
                                                <span >
                                                    {{(data.totalSellingPrice | customCurrency)}}    
                                                </span>

                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="accessoryItem">
                                            <th mat-header-cell *matHeaderCellDef class="customize-column">
                                                {{ 'ORDERMANAGEMENT.MANAGEORDERS.accessoryItem' | translate }}
                                            </th>
                                            <td mat-cell *matCellDef="let data" class="customize-column">
                                                <ng-container >
                                                    <mat-checkbox [(ngModel)]="data.isAccessoryItem" [disabled]="true">
                                                    </mat-checkbox>
                                                </ng-container>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="IsOptional">
                                            <th mat-header-cell *matHeaderCellDef class="total-selling-price-column">
                                                {{'ORDERMANAGEMENT.MANAGEORDERS.IsOptional' | translate}}
                                            </th>
                                            <td mat-cell *matCellDef="let data" class="total-selling-price-column">
                                                <div *ngIf="data.isOptional" class="button-view table-heading">
                                                    <button class="btn-style" (click)="addToProposal(data)">
                                                        {{'ORDERMANAGEMENT.MANAGEORDERS.AddtoProposal'|translate}}
                                                    </button>   
                                                </div>
                                             </td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true">
                                        </tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                                        </tr>
                                    </table>
                                    <div *ngIf="dataSource?.data?.length == 0" class="no-record text-center mt-15">
                                        {{'TABLE.No_record_found' | translate}} </div>
                                </div>
                            </div>
                            <div class="form-footer">
                                <div class="step-form-bottom">
                                    <div>
                                        <button routerLink="/customer-order" class="btn-style red-line-btn"
                                            type="button">{{'GENERAL.Cancel' |
                                            translate}}</button>
                                    </div>

                                    <div>
                                        <button class="btn-style privious-btn theme-btn" matStepperPrevious type="button"><span
                                            class="material-icons">arrow_backward</span>
                                          {{'GENERAL.Previous' | translate}} </button>
                                        <button *ngIf="orderDetails?.status === orderStatusApproveRejet.REVIEW_OFFER"  matStepperNext (click)="changeStatusApprove()"
                                            class="btn-style green-btn">
                                            {{'ORDERMANAGEMENT.MANAGEORDERS.Approve' | translate}}</button>
                                        <button *ngIf="orderDetails?.status === orderStatusApproveRejet.REVIEW_OFFER"  class="btn-style  red-btn " (click)="changeStatusReject()">
                                            {{'ORDERMANAGEMENT.MANAGEORDERS.Reject' | translate}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-step>

                </mat-horizontal-stepper>
            </div>
        </div>
    </div>
</section>
